import {
  DocumentReference,
  isDocRef,
  isObject,
  ISODateTimeWithUTCType,
  TypeGuard,
} from '@principle-theorem/shared';
import type { IPractice } from '../../../practice/practice';
import type { IKnowledgeBasePushBody } from './knowledge-base-push-body';
import {
  type IOvieHealthKnowledgeBaseActionPayloadMap,
  OvieHealthKnowledgeBaseAction,
  isOvieHealthKnowledgeBaseAction,
} from './knowledge-base-action';

export interface IOvieHealthKnowledgeBaseActionBodyMap {
  getKnowledgeBase: undefined;
  putKnowledgeBase: IKnowledgeBasePushBody;
  patchKnowledgeBase: Partial<IKnowledgeBasePushBody>;
}

export interface IOvieHealthKnowledgeBaseRequest<
  A extends OvieHealthKnowledgeBaseAction = OvieHealthKnowledgeBaseAction,
> {
  action: A;
  practiceRef: DocumentReference<IPractice>;
  body?: IOvieHealthKnowledgeBaseActionBodyMap[A];
  fields?: string[];
}

export const isOvieHealthKnowledgeBaseRequest =
  TypeGuard.interface<IOvieHealthKnowledgeBaseRequest>({
    action: isOvieHealthKnowledgeBaseAction,
    practiceRef: isDocRef,
    body: TypeGuard.undefinedOr(isObject),
    fields: TypeGuard.undefinedOr(TypeGuard.arrayOf(TypeGuard.isString)),
  });

export interface IOvieHealthKnowledgeBaseResponse<
  A extends OvieHealthKnowledgeBaseAction = OvieHealthKnowledgeBaseAction,
> {
  action: A;
  data: IOvieHealthKnowledgeBaseActionPayloadMap[A];
  fetchedAt: ISODateTimeWithUTCType;
}
